export const METHODS = {
  notification: {
    messagesUser: 'notification.messages_user',
    removeMessagesUser: 'notification.remove_messages_user',
  },
  users: {
    byId: 'users.by_id',
    list: 'users.list',
    create: 'users.create',
    update: 'users.update',
    updatePersonalRules: 'users.updatePersonalRules',
    delete: 'users.delete',
    me: 'users.me',
  },
  rbac: {
    rules: 'rbac.rules',
    role: 'rbac.role',
    roles: 'rbac.roles',
    modules: 'rbac.modules',
    createRule: 'rbac.create_rule',
    updateRule: 'rbac.update_rule',
    updateRole: 'rbac.update_role',
    divisions: 'rbac.divisions',
    create_division: 'rbac.create_division',
    update_division: 'rbac.update_division',
  },
  configuration: {
    featureFlagList: 'configuration.feature_flag_user_list',
    featureFlagUser: 'configuration.feature_flag_list',
    userConfiguration: 'configuration.user_configuration',
    userConfigurationUpdate: 'configuration.user_configuration_update',
    featureFlagListUpdate: 'configuration.feature_flag_update',
    featureFlagUserCreate: 'configuration.feature_flag_user_create',
    featureFlagUserDelete: 'configuration.feature_flag_user_delete',
    featureFlagUserUpdate: 'configuration.feature_flag_user_update',
  },
  classifiers: {
    station: {
      list: 'classifiers.station.list',
      byId: 'classifiers.station.byId',
      create: 'classifiers.station.create',
      update: 'classifiers.station.update',
    },
    branch: {
      byId: 'classifiers.branch.byId',
      list: 'classifiers.branch.list',
      create: 'classifiers.branch.create',
      update: 'classifiers.branch.update',
    },
    railway: {
      list: 'classifiers.railway.list',
      byId: 'classifiers.railway.byId',
      create: 'classifiers.railway.create',
      update: 'classifiers.railway.update',
    },
    mnemonic: {
      list: 'classifiers.mnemonic.list',
      update: 'classifiers.mnemonic.update',
    },
    structuralSubdivision: {
      list: 'classifiers.structuralSubdivision.list',
      byId: 'classifiers.structuralSubdivision.byId',
      create: 'classifiers.structuralSubdivision.create',
      update: 'classifiers.structuralSubdivision.update',
    },
    railwayAdministration: {
      list: 'classifiers.railwayAdministration.list',
      byId: 'classifiers.railwayAdministration.byId',
      create: 'classifiers.railwayAdministration.create',
      update: 'classifiers.railwayAdministration.update',
    },
    passengerCarrier: {
      list: 'classifiers.passengerCarrier.list',
      byId: 'classifiers.passengerCarrier.byId',
      create: 'classifiers.passengerCarrier.create',
      update: 'classifiers.passengerCarrier.update',
    },
    passengerCarrierCode: {
      list: 'classifiers.passengerCarrierCode.list',
      byId: 'classifiers.passengerCarrierCode.byId',
      create: 'classifiers.passengerCarrierCode.create',
      update: 'classifiers.passengerCarrierCode.update',
    },
    trainNumber: {
      list: 'classifiers.trainNumber.list',
      byId: 'classifiers.trainNumber.byId',
    },
    trainSubCategory: {
      list: 'classifiers.trainSubCategory.list',
      byId: 'classifiers.trainSubCategory.byId',
      create: 'classifiers.trainSubCategory.create',
      update: 'classifiers.trainSubCategory.update',
      byTrainNumber: 'classifiers.trainSubCategory.byTrainNumber',
    },
    trainSubCategoriesDetailsSpeed: {
      list: 'classifiers.trainSubCategoriesDetailsSpeed.list',
      create: 'classifiers.trainSubCategoriesDetailsSpeed.create',
      update: 'classifiers.trainSubCategoriesDetailsSpeed.update',
    },
    trainCategory: {
      list: 'classifiers.trainCategory.list',
      byId: 'classifiers.trainCategory.byId',
      create: 'classifiers.trainCategory.create',
      update: 'classifiers.trainCategory.update',
    },
    carriageType: {
      list: 'classifiers.carriageType.list',
      byId: 'classifiers.carriageType.byId',
      create: 'classifiers.carriageType.create',
      update: 'classifiers.carriageType.update',
    },
    gdp: {
      list: 'classifiers.gdp.list',
      byId: 'classifiers.gdp.byId',
      create: 'classifiers.gdp.create',
      update: 'classifiers.gdp.update',
    },
    availableServiceClass: {
      list: 'classifiers.availableServiceClass.list',
      create: 'classifiers.availableServiceClass.create',
      update: 'classifiers.availableServiceClass.update',
    },
    carriageServiceClass: {
      list: 'classifiers.carriageServiceClass.list',
      byId: 'classifiers.carriageServiceClass.byId',
      create: 'classifiers.carriageServiceClass.create',
      update: 'classifiers.carriageServiceClass.update',
    },
    carriageAdditionalSeatSign: {
      list: 'classifiers.carriageAdditionalSeatSign.list',
      byId: 'classifiers.carriageAdditionalSeatSign.byId',
      create: 'classifiers.carriageAdditionalSeatSign.create',
      update: 'classifiers.carriageAdditionalSeatSign.update',
    },
    carriageSeatAllocation: {
      list: 'classifiers.carriageSeatAllocation.list',
      byId: 'classifiers.carriageSeatAllocation.byId',
      create: 'classifiers.carriageSeatAllocation.create',
      update: 'classifiers.carriageSeatAllocation.update',
    },
    carriageTypeAsu: {
      list: 'classifiers.carriageTypeAsu.list',
      byId: 'classifiers.carriageTypeAsu.byId',
      create: 'classifiers.carriageTypeAsu.create',
      update: 'classifiers.carriageTypeAsu.update',
    },
    carriageTypeCsu: {
      list: 'classifiers.csuCarriageType.list',
      byId: 'classifiers.csuCarriageType.byId',
      create: 'classifiers.csuCarriageType.create',
      update: 'classifiers.csuCarriageType.update',
    },
    carriageTypeAsuDimensionSeatsCount: {
      list: 'classifiers.carriageTypeAsuDimensionSeatsCount.list',
      byId: 'classifiers.carriageTypeAsuDimensionSeatsCount.byId',
      create: 'classifiers.carriageTypeAsuDimensionSeatsCount.create',
      update: 'classifiers.carriageTypeAsuDimensionSeatsCount.update',
    },
    mvpsMartinSectionType: {
      list: 'classifiers.mvpsMartinSectionType.list',
      byId: 'classifiers.mvpsMartinSectionType.byId',
      create: 'classifiers.mvpsMartinSectionType.create',
      update: 'classifiers.mvpsMartinSectionType.update',
    },
    mvpsMartinSectionTypeEquipment: {
      list: 'classifiers.mvpsMartinSectionTypeEquipment.list',
      byId: 'classifiers.mvpsMartinSectionTypeEquipment.byId',
      create: 'classifiers.mvpsMartinSectionTypeEquipment.create',
      update: 'classifiers.mvpsMartinSectionTypeEquipment.update',
    },
    mvpsCompanyAffiliation: {
      list: 'classifiers.mvpsCompanyAffiliation.list',
      byId: 'classifiers.mvpsCompanyAffiliation.byId',
      create: 'classifiers.mvpsCompanyAffiliation.create',
      update: 'classifiers.mvpsCompanyAffiliation.update',
    },
    mvpsRateManagementExploitationMaintenanceRepair: {
      list: 'classifiers.mvpsRateManagementExploitationMaintenanceRepair.list',
      byId: 'classifiers.mvpsRateManagementExploitationMaintenanceRepair.byId',
      create:
        'classifiers.mvpsRateManagementExploitationMaintenanceRepair.create',
      update:
        'classifiers.mvpsRateManagementExploitationMaintenanceRepair.update',
    },
    trainBrand: {
      list: 'classifiers.trainBrand.list',
      byId: 'classifiers.trainBrand.byId',
      create: 'classifiers.trainBrand.create',
      update: 'classifiers.trainBrand.update',
    },
    npsCarriageDimension: {
      list: 'classifiers.npsCarriageDimension.list',
      byId: 'classifiers.npsCarriageDimension.byId',
      create: 'classifiers.npsCarriageDimension.create',
      update: 'classifiers.npsCarriageDimension.update',
    },
    npsCarriageModel: {
      list: 'classifiers.npsCarriageModel.list',
      byId: 'classifiers.npsCarriageModel.byId',
      create: 'classifiers.npsCarriageModel.create',
      update: 'classifiers.npsCarriageModel.update',
    },
    npsCarriageBrakeType: {
      list: 'classifiers.npsCarriageBrakeType.list',
      byId: 'classifiers.npsCarriageBrakeType.byId',
      create: 'classifiers.npsCarriageBrakeType.create',
      update: 'classifiers.npsCarriageBrakeType.update',
    },
    npsCarriageHeatType: {
      list: 'classifiers.npsCarriageHeatType.list',
      byId: 'classifiers.npsCarriageHeatType.byId',
      create: 'classifiers.npsCarriageHeatType.create',
      update: 'classifiers.npsCarriageHeatType.update',
    },
    npsCarriageLength: {
      list: 'classifiers.npsCarriageLength.list',
      byId: 'classifiers.npsCarriageLength.byId',
      create: 'classifiers.npsCarriageLength.create',
      update: 'classifiers.npsCarriageLength.update',
    },
    transportationPerformanceIndicator: {
      list: 'classifiers.transportationPerformanceIndicator.list',
      byId: 'classifiers.transportationPerformanceIndicator.byId',
      create: 'classifiers.transportationPerformanceIndicator.create',
      update: 'classifiers.transportationPerformanceIndicator.update',
    },
    maxTrainSpeed: {
      list: 'classifiers.maxTrainSpeed.list',
      byId: 'classifiers.maxTrainSpeed.byId',
      create: 'classifiers.maxTrainSpeed.create',
      update: 'classifiers.maxTrainSpeed.update',
    },
    periodicitySeason: {
      list: 'classifiers.periodicitySeason.list',
      byId: 'classifiers.periodicitySeason.byId',
      create: 'classifiers.periodicitySeason.create',
      update: 'classifiers.periodicitySeason.update',
    },
    conditionalCarriageNumber: {
      list: 'classifiers.conditionalCarriageNumber.list',
      byId: 'classifiers.conditionalCarriageNumber.byId',
      create: 'classifiers.conditionalCarriageNumber.create',
      update: 'classifiers.conditionalCarriageNumber.update',
    },
    nonPassengerCarriageType: {
      list: 'classifiers.nonPassengerCarriageType.list',
      byId: 'classifiers.nonPassengerCarriageType.byId',
      create: 'classifiers.nonPassengerCarriageType.create',
      update: 'classifiers.nonPassengerCarriageType.update',
    },
    carriageTypesForSchema: {
      list: 'classifiers.carriageTypesForSchema.list',
      byId: 'classifiers.carriageTypesForSchema.byId',
      create: 'classifiers.carriageTypesForSchema.create',
      update: 'classifiers.carriageTypesForSchema.update',
    },
    locomotiveSeries: {
      list: 'classifiers.locomotiveSeries.list',
      byId: 'classifiers.locomotiveSeries.byId',
      create: 'classifiers.locomotiveSeries.create',
      update: 'classifiers.locomotiveSeries.update',
    },
    locomotiveSeriesType: {
      list: 'classifiers.locomotiveSeriesType.list',
      byId: 'classifiers.locomotiveSeriesType.byId',
      create: 'classifiers.locomotiveSeriesType.create',
      update: 'classifiers.locomotiveSeriesType.update',
    },
    locomotiveTractionType: {
      list: 'classifiers.locomotiveTractionType.list',
      byId: 'classifiers.locomotiveTractionType.byId',
      create: 'classifiers.locomotiveTractionType.create',
      update: 'classifiers.locomotiveTractionType.update',
    },
    locomotiveTypeCurrent: {
      list: 'classifiers.locomotiveTypeCurrent.list',
      byId: 'classifiers.locomotiveTypeCurrent.byId',
      create: 'classifiers.locomotiveTypeCurrent.create',
      update: 'classifiers.locomotiveTypeCurrent.update',
    },
    tractionDirectorate: {
      list: 'classifiers.tractionDirectorate.list',
      byId: 'classifiers.tractionDirectorate.byId',
      create: 'classifiers.tractionDirectorate.create',
      update: 'classifiers.tractionDirectorate.update',
    },
    userStructuralUnit: {
      create: 'classifiers.userStructuralUnit.create',
      update: 'classifiers.userStructuralUnit.update',
    },
    infrastructureCoefficientIndexing: {
      list: 'classifiers.infrastructureCoefficientIndexing.list',
      byId: 'classifiers.infrastructureCoefficientIndexing.byId',
      create: 'classifiers.infrastructureCoefficientIndexing.create',
      update: 'classifiers.infrastructureCoefficientIndexing.update',
    },
    infrastructureApplication23: {
      list: 'classifiers.infrastructureApplication23.list',
      byId: 'classifiers.infrastructureApplication23.byId',
      create: 'classifiers.infrastructureApplication23.create',
      update: 'classifiers.infrastructureApplication23.update',
    },
    infrastructureApplication24: {
      list: 'classifiers.infrastructureApplication24.list',
      byId: 'classifiers.infrastructureApplication24.byId',
      create: 'classifiers.infrastructureApplication24.create',
      update: 'classifiers.infrastructureApplication24.update',
    },
    infrastructureApplication25: {
      list: 'classifiers.infrastructureApplication25.list',
      byId: 'classifiers.infrastructureApplication25.byId',
      create: 'classifiers.infrastructureApplication25.create',
      update: 'classifiers.infrastructureApplication25.update',
    },
    infrastructureApplication26: {
      list: 'classifiers.infrastructureApplication26.list',
      byId: 'classifiers.infrastructureApplication26.byId',
      create: 'classifiers.infrastructureApplication26.create',
      update: 'classifiers.infrastructureApplication26.update',
    },
    infrastructureApplication27: {
      list: 'classifiers.infrastructureApplication27.list',
      byId: 'classifiers.infrastructureApplication27.byId',
      create: 'classifiers.infrastructureApplication27.create',
      update: 'classifiers.infrastructureApplication27.update',
    },
    locomotiveServiceEmpiricalParameter: {
      list: 'classifiers.locomotiveServiceEmpiricalParameter.list',
      byId: 'classifiers.locomotiveServiceEmpiricalParameter.byId',
      create: 'classifiers.locomotiveServiceEmpiricalParameter.create',
      update: 'classifiers.locomotiveServiceEmpiricalParameter.update',
    },
    locomotiveTeamPriceRent: {
      list: 'classifiers.locomotiveTeamPriceRent.list',
      byId: 'classifiers.locomotiveTeamPriceRent.byId',
      create: 'classifiers.locomotiveTeamPriceRent.create',
      update: 'classifiers.locomotiveTeamPriceRent.update',
    },
    locomotivePriceTechnicalService: {
      list: 'classifiers.locomotivePriceTechnicalService.list',
      byId: 'classifiers.locomotivePriceTechnicalService.byId',
      create: 'classifiers.locomotivePriceTechnicalService.create',
      update: 'classifiers.locomotivePriceTechnicalService.update',
    },
    routesControlAvailabilitySeatsDirections: {
      list: 'classifiers.routesControlAvailabilitySeatsDirection.list',
      byId: 'classifiers.routesControlAvailabilitySeatsDirection.byId',
      create: 'classifiers.routesControlAvailabilitySeatsDirection.create',
      update: 'classifiers.routesControlAvailabilitySeatsDirection.update',
    },
  },
  carriageGroups: {
    carriageGroupById: 'carriageGroups.carriageGroupById',
    carriageGroupList: 'carriageGroups.carriageGroupList',
    exportCarriageGroupsList: 'carriageGroups.exportCarriageGroupsList',
    getDatesDataToAddTimeStagnation:
      'carriageGroups.getDatesDataToAddTimeStagnation',
    getDatesDataToUpdateTimeStagnation:
      'carriageGroups.getDatesDataToUpdateTimeStagnation',
    createCarriageGroup: 'carriageGroups.createCarriageGroup',
    updateCarriageGroup: 'carriageGroups.updateCarriageGroup',
    deleteCarriageGroup: 'carriageGroups.deleteCarriageGroup',
    addTurnover: 'carriageGroups.addTurnover',
    updateTurnover: 'carriageGroups.updateTurnover',
    deleteTurnover: 'carriageGroups.deleteTurnover',
    addPeriodicity: 'carriageGroups.addPeriodicity',
    updatePeriodicity: 'carriageGroups.updatePeriodicity',
    deletePeriodicity: 'carriageGroups.deletePeriodicity',
    addTurnoverTimeStagnation: 'carriageGroups.addTurnoverTimeStagnation',
    updateTurnoverTimeStagnation: 'carriageGroups.updateTurnoverTimeStagnation',
    deleteTurnoverTimeStagnation: 'carriageGroups.deleteTurnoverTimeStagnation',
    deleteCarriageParameters: 'carriageGroups.deleteCarriageParameters',

    updateCarriageAdditionalInfoParameters:
      'carriageGroups.updateCarriageAdditionalInfoParameters',

    trailedDirectGroupById: 'carriageGroups.trailedDirectGroupById',
    trailedDirectGroupList: 'carriageGroups.trailedDirectGroupList',
    createTrailedDirectGroup: 'carriageGroups.createTrailedDirectGroup',
    deleteTrailedDirectGroup: 'carriageGroups.deleteTrailedDirectGroup',
    exportTrailedDirectGroupsList:
      'carriageGroups.exportTrailedDirectGroupsList',
    copy: 'carriageGroups.copy',
    exportCarriageGroupToSchemas: 'carriageGroups.exportCarriageGroupToSchemas',
    carriageGroupTurnoverChart: 'carriageGroups.getCarriageGroupTurnoverChart',
    revoke: 'carriageGroups.revokeCarriageGroup',
  },
  journal: {
    userActionAudit: 'journal.user_action_audit',
  },
  scheduler: {
    update_time_job: 'scheduler.scheduler.updateTimeJob',
  },
  train: {
    byId: 'train.byId',
    list: 'train.list',
    pair: 'train.pair',
    create: 'train.create',
    update: 'train.update',
    delete: 'train.delete',
    checkScheduleCopyPossibility: 'train.checkScheduleCopyPossibility',
    copySchedule: 'train.copySchedule',
    createVersion: 'train.createVersion',
    toApproval: 'train.toApproval',
    toApproved: 'train.toApproved',
    toPlanning: 'train.toPlanning',
    approveBySubdivision: 'train.approveBySubdivision',
    declineBySubdivision: 'train.declineBySubdivision',
  },
  train_schedules: {
    byId: 'train_schedules.byId',
    list: 'train_schedules.list',
    getScheduleStencil: 'train_schedules.getScheduleStencil',
    createTrainSchedule: 'train_schedules.createTrainSchedule',
    updateTrainSchedule: 'train_schedules.updateTrainSchedule',
    deleteTrainSchedule: 'train_schedules.deleteTrainSchedule',
  },
  train_schemas: {
    list: 'train_schemas.list',
    byId: 'train_schemas.byId',
    checkIsSpreadPossibleToAllSchemas:
      'train_schemas.checkIsSpreadPossibleToAllSchemas',
    create: 'train_schemas.create',
    delete: 'train_schemas.delete',
    update: 'train_schemas.update',
    spreadBlockToAllSchemas: 'train_schemas.spreadBlockToAllSchemas',
    approveCarriageGroup: 'train_schemas.approveCarriageGroup',
    declineCarriageGroup: 'train_schemas.declineCarriageGroup',
  },
  indicators: {
    updateForecastIndicator: 'indicators.updateForecastIndicator',
  },
  cms: {
    news_list: 'cms.news_list',
    news_update: 'cms.news_update',
    news_delete: 'cms.news_delete',
    news_create: 'cms.news_create',

    faq_list: 'cms.faq_list',
    faq_create: 'cms.faq_create',
    faq_update: 'cms.faq_update',
    faq_delete: 'cms.faq_delete',

    education_list: 'cms.education_list',
    education_create: 'cms.education_create',
    education_update: 'cms.education_update',
    education_delete: 'cms.education_delete',
  },
};
